import * as api from '../api'

//Action Creators
export const getAllUnits = () => async (dispatch) => {
  try {
    const { data } = await api.fetchAllUnits()
    dispatch({ type: 'FETCH_ALL_UNITS', payload: data })
  } catch (error) {
    dispatch({
      type: 'API_ERROR',
      payload: error.response.data.message,
    })
  }
}
